import { createClient } from '@urql/core';
import { v4 as uuidv4 } from 'uuid';

import { useStore } from '../composables/store.composable';

import { HttpHeaders } from '../models/entities/graphql.model';

import { HTTP_HEADERS } from '../models/constants';

import SeamlessStoreService from '@dh-io-otb/shared/src/services/seamless-store.service';

export default class GraphQLService {
  client: any;

  constructor(url?: string) {
    this.client = this.startGraphQL(url);
  }

  static getClient(apiUri: string): any {
    return {
      url: GraphQLService.getEndpoint(apiUri),
      fetchOptions: () => {
        return {
          ...GraphQLService.generateHttpHeaders(),
        };
      },
      requestPolicy: 'network-only',
    };
  }

  static generateHttpHeaders(): HttpHeaders {
    const context = {
      headers: {
        [HTTP_HEADERS.REQUEST_ID]: uuidv4(),
        [HTTP_HEADERS.JOURNEY_ID]: uuidv4(),
        [HTTP_HEADERS.AUTORIZATION]: GraphQLService.getBearer(),
      },
    };
    return context;
  }

  static getBearer(): string {
    const { state } = useStore();
    return `Bearer ${state?.otbcUser?.token}`;
  }

  static getEndpoint(apiUri: string): string {
    return `${apiUri}/otbgs/v1/graphql`;
  }

  static getStandaloneFFGUrl(): string {
    const assetsServer = window.location.hostname;
    if (assetsServer.indexOf('test.assets.oneweb.mercedes-benz.com') != -1) {
      return 'https://test.api.oneweb.mercedes-benz.com';
    } else if (
      assetsServer.indexOf('int.assets.oneweb.mercedes-benz.com') != -1
    ) {
      return 'https://int.api.oneweb.mercedes-benz.com';
    } else if (assetsServer.indexOf('assets.oneweb.mercedes-benz.com') != -1) {
      return 'https://api.oneweb.mercedes-benz.com';
    } else {
      return 'https://test.api.oneweb.mercedes-benz.com';
    }
  }

  startGraphQL(url?: string): any {
    const aemConfig = window.sessionStorage.getItem(
      'ow_aem_apiGatewayConfiguration'
    );
    const aemConfigObject: any = aemConfig ? JSON.parse(aemConfig) : '';

    const uri =
      url ||
      SeamlessStoreService?.getApiUri() ||
      aemConfigObject?.apiGatewayUrl ||
      process.env.VUE_APP_OTBGS_BASE ||
      GraphQLService.getStandaloneFFGUrl();

    return createClient(GraphQLService.getClient(uri));
  }
}

const clientInstance = (url?: string): any => new GraphQLService(url);
export { clientInstance };
